<template>
  <div
    class="wg-row com-anm22-tasks-task-bar"
    :style="'border-left:4px solid ' + borderColor"
    @click="viewTask"
  >
    <div class="wg-col wg-xs-1">
      <div class="wg-row" style="height:100%;flex-wrap:nowrap;align-items:center;justify-content:center;">
        <img
          class="com-anm22-app-img-fixed-height-s"
          :src="getPriorityIcon(taskData.priority)"
          :title="$anm22.tableClasses.taskPriority().getById(taskData.priority)[lang]"
        >
      </div>
    </div>
    <div
      :class="['wg-col', view === 'full' ? 'wg-xs-5' : 'wg-xs-7', 'com-anm22-task-bar-name']"
      style="padding:10px;"
    >
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <img 
        v-if="!isSynchronized" 
        class="com-anm22-app-img-fixed-height-s"
        :src="$anm22.icons.getWorldIcon('offline')" 
        style="margin-right:5px;"
        :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
      >
      <div class="com-anm22-app-text-m taskName" style="font-weight:bold;">
       {{ taskData.name }}
      </div>
    </div>
    </div>
    <!-- Utenti con il permesso di accesso - Staff -->
    <div class="wg-col wg-xs-2 users-div">
      <div 
          v-for="(user,index) in taskUsers"
          :key="'u-'+index">
        <world-object-icon
            :type="'user'" 
            :obj="user"
            :isImg="true">
        </world-object-icon>
      </div>
      <div v-for="(job,index) in taskJobs" :key="'job'+index">
        <div :title="$anm22.strLang(lang, job.en, job.it)" class="job-icon"> {{ $anm22.strLang(lang, job.en, job.it).substring(0,1).toUpperCase() }} </div>
      </div>
    </div>
    <!-- Stato del task -->
    <div v-if="view === 'full'" class="wg-col wg-xs-2">
      <div
        :class="[
          'com-anm22-app-align-center', 
          'status', 
          $anm22.tableClasses.taskStatus().getById(taskData.status).typeClassLiteral
        ]"
        style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
      >{{ $anm22.tableClasses.taskStatus().getById(taskData.status)[lang] }}</div>
    </div>
    <!-- Termine del task -->
    <div class="wg-col wg-xs-2 display-flex date-div">
      <div
        class="com-anm22-app-text-l"
        :style="taskData.deadline !== taskData.actualEndDate ? 'color:#00B0FF;' : ''"
        :title="taskData.deadline ? $moment.unix(taskData.deadline).utc().format('DD MMMM YYYY') : ''"
      >{{ taskData.deadline ? $moment.unix(taskData.deadline).utc().format( view === 'full' ? 'D MMM YYYY' : 'D MMM') : '' }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    view: {
      type: String,
      default: 'cols'
    },
    taskData: Object
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    isSynchronized() {
      return this.$store.getters['offline/isSynchronized'](this.$anm22.MD5('WorldTask' + this.taskData.id));
    },
    borderColor() {
      switch (this.taskData.status) {
        case 1:
          return "#bdbdbd";
        case 2:
          return "#ffeb3b";
        case 3:
          return "#01d479";
      }
    },
    taskUsers() {
      if (this.taskData.users) {
        return this.taskData.users.map(u => this.$store.getters["users/get"](u));
      } else {
        return [];
      }
    },
    taskJobs() {
      let project = this.$store.getters['projects/get'](this.taskData.project);
      let licenses = project.developers
        .map(w => this.$store.getters["licenses/get"](w))
        .filter(l => l);
      let jobs =  licenses.reduce(
        (acc, license) =>
          acc.concat(
            license.config && license.config.tasks && license.config.tasks.jobs
          ),
        []
      );
      return this.taskData.jobs.map(taskJob =>
        jobs.find(j => j.id === taskJob)
      )

    }
  },
  methods: {
    viewTask() {
      this.$emit("open-task", this.taskData.id);
    },
    getPriorityIcon(id) {
      switch (id) {
        case 1:
          return this.$anm22.icons.getWorldIcon("priorityLowest");
        case 2:
          return this.$anm22.icons.getWorldIcon("priorityLow");
        case 3:
          return this.$anm22.icons.getWorldIcon("priorityMedium");
        case 4:
          return this.$anm22.icons.getWorldIcon("priorityHigh");
        case 5:
          return this.$anm22.icons.getWorldIcon("priorityHighest");
      }
    }
  },
  watch: {
    view(oldVal, newVal) {
      this.view = newVal;
    }
  }
};
</script>

<style lang="scss" scoped>
.status {
  font-size: 14px;
  width: 100%;
  height: 100%;
  padding: 10px 5px;
  box-sizing: border-box;
  margin-bottom: 0;
  &.waiting {
    background-color: #bdbdbd;
  }
  &.running {
    background-color: #ffeb3b;
  }
  &.completed {
    color: #fff;
    background-color: #01d479;
  }
}
.users-div {
  display:flex;
  overflow:hidden;
  height:34px;
  padding:6px;
  white-space:nowrap;
  box-sizing:border-box;
  position: relative;
}
.users-div > div {
  position: absolute;
  min-width:26px;
  width:26px;
  height:26px;
  display: block;
  border: 2px solid #fff;
  border-radius: 13px;
  top:4px;
  left:0px;
}
.users-div > div:nth-child(1) {
  left:0px;
  z-index: 11;
}
.users-div > div:nth-child(2) {
  left:20px;
  z-index: 10;
}
.users-div > div:nth-child(3) {
  left:40px;
  z-index: 9;
}
.users-div > div:nth-child(4) {
  left:60px;
  z-index: 8;
}
.users-div > div:nth-child(5) {
  left:80px;
  z-index: 7;
}
.users-div > div:nth-child(6) {
  left:100px;
  z-index: 6;
}
.users-div > div:nth-child(7) {
  left:120px;
  z-index: 5;
}
.users-div > div:nth-child(8) {
  left:140px;
  z-index: 4;
}
.users-div > div:nth-child(9) {
  left:160px;
  z-index: 3;
}
.users-div > div:nth-child(10) {
  left:180px;
  z-index: 2;
}
.date-div {
  padding: 8px;
  justify-content:center;
  overflow:hidden;
  white-space:nowrap;
}
.offline-icon {
  display:inline-block;
  vertical-align:middle;
  width:16px; 
  margin-right:5px; 
}
div.job-icon {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #007fff;
  border-radius: 50%;
  user-select: none;
  font-size: 14px;
}
.job-icon {
  width: 100%;
  height: 100%;
  padding: 0;
}
</style>

